import "./Modal.scss";

function Modal() {

    function closeCurrentWindow() {
        const modal = document.querySelector(".modal");
        modal.classList.add("d-none");
    }

    return (
        <div className="modal mt-3 mt-md-4" id="infoModal-contacto" role="dialog">
            <div className="modal-dialog" role="document">
                <div className="modal-content">
                    <div className="modal-header">
                        <button type="button" className="close" onClick={closeCurrentWindow}>
                            <span aria-hidden="true">&times;</span>
                        </button>
                    </div>
                    <div className="modal-error">
                        <div className="form-mensaje-ko">
                            <div>
                                <i className="close-icon"></i>
                            </div>
                        </div>
                        <p className="px-4">
                            Hubo un error intentando enviar su mensaje. Por favor inténtelo de nuevo más tarde.
                        </p>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default Modal;